import {
    ApolloClient,
    ApolloLink,
    createHttpLink,
    InMemoryCache,
} from '@apollo/client'
import Auth from '@aws-amplify/auth'
import { createAuthLink } from 'aws-appsync-auth-link'

import awsconfig from '../aws-exports'

// this link ensures that queries are properly authenticated using the appropriate
// headers and/or tokens
const authLink = createAuthLink({
    url: awsconfig.aws_appsync_graphqlEndpoint,
    region: awsconfig.aws_appsync_region,
    auth: {
        type: awsconfig.aws_appsync_authenticationType as 'AMAZON_COGNITO_USER_POOLS',
        jwtToken: async () => {
            const session = await Auth.currentSession()
            const token = session.getIdToken()
            const jwt = token.getJwtToken()
            return jwt
        },
    },
})

const httpLink = createHttpLink({ uri: awsconfig.aws_appsync_graphqlEndpoint })

const link = ApolloLink.from([authLink, httpLink])

export const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
})
